// ======================================================================
// File Name       : ContentDocumentContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import moment from 'moment';
import $ from 'jquery';
import { Field, reduxForm, isInvalid, getFormValues, change, isDirty } from 'redux-form';
import { connect } from 'react-redux';
import { Button, Form, Col } from 'react-bootstrap';
import ThumbNail from '../../components/course/ThumbNail';
import ContentDocumentList from '../../components/content/ContentDocumentList';
import DialogConfirm from '../../components/DialogConfirm';
import * as InitialImageAction from '../../actions/InitialImageAction';
import * as MessageTemplate from '../../constants/MessageTemplate';
import {
  INITIAL_IMAGE,
  TITLE_OBJ_STR,
  TITLE_OBJ,
  IMAGE_TYPE_INT,
  DEFAULT_THUMBNAIL,
} from '../../constants/InitialImageConstants';
import {
  VALIDATE_TYPE,
  RETURN_MAX_NUM,
  DEFAULT_DATE_FORMAT_SERVER,
  MODE,
  ROOT_URL,
} from '../../constants/index';
import RenderField from '../../utils/ReduxFormUtils';
import { showLoading, hideLoading } from '../../utils/PageUtils';
import { hasProperty } from '../../utils/index';
import Header from '../../components/Header';
import { HIDE_MESSAGE } from '../../constants/actionTypes/message';
import * as Path from '../../constants/PathConstants';
import CustomLink from '../../components/button/CustomLink';

// let okBtnClick = false;

class CourseDefaultThumbnailContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialData: {
        imageFileSelectType: INITIAL_IMAGE.IMAGE_SYSTEMS,
        imageType: null,
        imageFileUpload: null,
        thumbnailUrl: '',
      },
      initialImageList: [],
      initialImageObject: null,
      okBtnClick: false,
    };
    this.handleImageFileChange = this.handleImageFileChange.bind(this);
    this.getInitialImage = this.getInitialImage.bind(this);
    this.createParams = this.createParams.bind(this);
    this.onConfirmDialogCancel = this.onConfirmDialogCancel.bind(this);
    this.onConfirmDialogOk = this.onConfirmDialogOk.bind(this);
    this.createParamUpload = this.createParamUpload.bind(this);
    this.openConfirmDialog = this.openConfirmDialog.bind(
      this,
      MessageTemplate.MSG_CONFIRM_UPDATE,
      null,
    );
    this.radioChange = this.radioChange.bind(this);
  }

  componentWillMount() {
    this.getInitialImage();
  }

  getInitialImage() {
    const paramGetInitialImage = this.createParams();
    this.props.dispatch(InitialImageAction.getInitialImage(paramGetInitialImage));
  }

  createParams() {
    const param = {
      searchInfo: {},
    };
    return param;
  }

  handleImageFileChange(event) {
    if (event.target.files.length !== 0) {
      const nameTarget = event.target.name;
      const { formValues } = this.props;
      const reader = new FileReader();
      const file = event.target.files[0];
      if (formValues && Object.keys(formValues).length) {
        const place = nameTarget.indexOf('.');
        const nameKey = nameTarget.slice(0, place);
        if (hasProperty(formValues, nameKey)) {
          reader.onloadend = () => {
            const newFormValue = { ...formValues[nameKey] };
            newFormValue.imageFileUpload = file;
            newFormValue.thumbnailUrlFileLoad = reader.result;
            newFormValue.imageFileSelectType = INITIAL_IMAGE.IMAGE_SELECTION;
            newFormValue.changed = true;
            this.props.dispatch(change('courseDefaultThumbnail', nameKey, newFormValue));
          };
          reader.readAsDataURL(file);
        }
      }
    }
  }

  radioChange(event, newValue, previousValue) {
    const { formValues, initialImageObject } = this.props;
    if (formValues && Object.keys(formValues).length) {
      const nameTarget = event.target.name;
      const place = nameTarget.indexOf('.');
      const nameKey = nameTarget.slice(0, place);
      if (hasProperty(formValues, nameKey)) {
        if (formValues[nameKey].imageFileSelectType !== newValue) {
          const newFormValue = { ...formValues[nameKey] };
          if (newValue === initialImageObject[nameKey].imageFileSelectType) {
            newFormValue.thumbnailUrl = initialImageObject[nameKey].thumbnailUrl;
            newFormValue.thumbnailUrlFileLoad = initialImageObject[nameKey].thumbnailUrl;
          } else if (newValue === INITIAL_IMAGE.IMAGE_SYSTEMS) {
            // set default thumbnail
            const thumbnail = $.grep(DEFAULT_THUMBNAIL, e => e.value === formValues[nameKey].imageType);
            newFormValue.thumbnailUrl = thumbnail && thumbnail.length ?
              `${ROOT_URL}/DefaultThumbnail/${thumbnail[0].name}` : '';

            // clear file upload
            const id = `${nameKey}imageFileUpload`;
            $(`#${id}`).val('');
          } else if (newValue === INITIAL_IMAGE.IMAGE_SELECTION) {
            // show NoImage
            newFormValue.thumbnailUrlFileLoad = '';
            newFormValue.imageFileUpload = '';
          }

          newFormValue.imageFileSelectType = newValue;
          newFormValue.changed = true;
          this.props.dispatch(change('courseDefaultThumbnail', nameKey, newFormValue));
        }
      }
    }
  }

  openConfirmDialog(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showExportModal: true });
  }

  /**
 * Action click cancel button in dialog
 */
  onConfirmDialogCancel() {
    this.setState({ showExportModal: false });
  }

  onConfirmDialogOk() {
    const { initialImageObject, auth, dispatch, formValues } = this.props;
    const listParams = [];
    this.setState({ showExportModal: false, okBtnClick: true }, () => {
      if (formValues && Object.keys(formValues).length) {
        Object.keys(formValues).map((childKey) => {
          if (hasProperty(formValues, childKey)) {
            if (formValues[childKey] && Object.keys(formValues[childKey]).length) {
              const param = this.createParamUpload(formValues[childKey], childKey);
              if (param) listParams.push(param);
            }
          }
          return null;
        });
      }
      if (listParams.length > 0) {
        this.props.dispatch(InitialImageAction.editInitialImage(auth, listParams)).then((error) => {
          this.setState({ okBtnClick: false });
          if (!error) {
            const container = $('#sroll-container');
            if (container && container.length) {
              container.scrollTop(0);
            }
            this.getInitialImage();
            // Hide error message after uploading thumbnail successful
            this.props.dispatch({ type: HIDE_MESSAGE });
          }
        });
      }
    });
  }

  createParamUpload(obj, childKey) {
    if (!obj) return null;
    const { initialImageObject } = this.props;
    const param = {
      editType: MODE.EDIT_MODE,
    };
    if (!obj.changed) return null;
    const imageType = parseInt(obj.imageType, 10);
    !isNaN(imageType) && (param.imageType = imageType);
    if (obj.imageFileSelectType === INITIAL_IMAGE.IMAGE_SELECTION) {
      obj.imageFileUpload && (param.imageFileUpload = obj.imageFileUpload);
    } else {
      param.editType = MODE.DELETE_MODE;
    }
    return param;
  }

  render() {
    const { initialImageList, initialImageObject, formValues, dirty, invalid } = this.props;
    return (
      <div>
        <Form className='form-horizontal'>
          <Col sm={12} className="margin-top-10">
            <ThumbNail
              formValues={formValues}
              handleImageFileChange={this.handleImageFileChange}
              radioChange={this.radioChange}
            />
          </Col>
          <Col sm={12} className="text-center margin-bottom-20">
            <Button
              variant="primary"
              className="btn-96 text-center margin-top-20 margin-right-30"
              onClick={this.props.handleSubmit(this.openConfirmDialog)}
              disabled={invalid || !dirty || this.state.okBtnClick}
            >
              OK
            </Button>
          </Col>
          <DialogConfirm
            showModal={this.state.showExportModal}
            onCancel={this.onConfirmDialogCancel}
            mdSize={this.mdSize}
            content={MessageTemplate.MSG_CONFIRM_UPDATE}
            onOK={this.onConfirmDialogOk}
          />
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { initialImage } = state;
  const { initialData, initialImageList } = state.initialImage;
  const { initialImageObject } = state.initialImage;
  const { courseDefaultThumbnail } = state.form;
  const formValues = getFormValues('courseDefaultThumbnail')(state);
  const dirty = isDirty('courseDefaultThumbnail')(state);
  const invalid = isInvalid('courseDefaultThumbnail')(state);
  return {
    initialData,
    ...{ initialImageList },
    ...{ initialImageObject },
    initialValues: initialImageObject,
    formValues,
    dirty,
    invalid,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'courseDefaultThumbnail', // a unique identifier for this form
    enableReinitialize: true,
  })(CourseDefaultThumbnailContainer),
);
